import { useGetNavigationMenu } from "../../Shared/Navigation/navigationMenu/useGetNavigationMenu";
import {
  NavigationItem as NavigationItemParams,
  NavigationSection as NavigationSectionParams,
} from "../../Shared/Navigation/navigationMenu/types";
import { useAdminMenuPriviligesProviderContext } from "../../Shared/Navigation/priviligesProviders/AdminMenuPriviligesProvider";
import { useWorkerMenuPriviligesProviderContext } from "../../Shared/Navigation/priviligesProviders/WorkerMenuPriviligesProvider";
import { useWorkplaceMenuPriviligesProviderContext } from "../../Shared/Navigation/priviligesProviders/WorkplaceMenuPriviligesProvider";
import { useUnreadChannelCount } from "../../Shared/Navigation/useUnreadChannelCount";
import { NavigationMenuItemDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuItem";
import { NavigationMenuSectionTitleDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuSectionTitle";

export interface NavigationMenuItemsDesktopProps {
  isAdmin: boolean;
  isWorkplace: boolean;
  isWorker: boolean;
}

function NavigationItem(params: NavigationItemParams) {
  const { label, iconType, isSelected, routeTo, onClick, badgeCount } = params;

  return (
    <NavigationMenuItemDesktop
      iconType={iconType}
      isSelected={isSelected}
      routeTo={routeTo}
      onClick={onClick}
      badgeCount={badgeCount}
    >
      {label}
    </NavigationMenuItemDesktop>
  );
}

function NavigationSection(params: NavigationSectionParams) {
  const { label, items } = params;

  return (
    <>
      <NavigationMenuSectionTitleDesktop>{label}</NavigationMenuSectionTitleDesktop>
      {items.map((item) => (
        <NavigationItem key={item.label} {...item} />
      ))}
    </>
  );
}

export function NavigationMenuItemsDesktop(props: NavigationMenuItemsDesktopProps) {
  const { isAdmin, isWorker, isWorkplace } = props;

  const currentPath = location.pathname;
  const adminMenuPriviliges = useAdminMenuPriviligesProviderContext();
  const workplaceMenuPriviliges = useWorkplaceMenuPriviligesProviderContext();
  const workerMenuPriviliges = useWorkerMenuPriviligesProviderContext();
  const unreadChannelCount = useUnreadChannelCount();

  const navigationMenu = useGetNavigationMenu(
    isAdmin,
    adminMenuPriviliges,
    isWorker,
    workerMenuPriviliges,
    isWorkplace,
    workplaceMenuPriviliges,
    currentPath,
    { unreadChannelCount }
  );

  return (
    <>
      {navigationMenu.items.map((item) =>
        "items" in item ? (
          <NavigationSection key={item.label} {...item} />
        ) : (
          <NavigationItem key={item.label} {...item} />
        )
      )}
    </>
  );
}
